export const REPORTS = {
  GET_PHOTO_REPORTS: 'GET_PHOTO_REPORTS',
  GET_PHOTO_REPORTS_SUCCESS: 'GET_PHOTO_REPORTS_SUCCESS',
  GET_PHOTO_REPORTS_FAIL: 'GET_PHOTO_REPORTS_FAIL',

  GET_VIDEO_REPORTS: 'GET_VIDEO_REPORTS',
  GET_VIDEO_REPORTS_SUCCESS: 'GET_VIDEO_REPORTS_SUCCESS',
  GET_VIDEO_REPORTS_FAIL: 'GET_VIDEO_REPORTS_FAIL',

  CLEAR_REPORTS: 'CLEAR_REPORTS',
  UPLOAD_REPORT: 'UPLOAD_REPORT',
  DELETE_REPORT: 'DELETE_REPORT',
  REPORTS_UPDATE_TIME: 'REPORTS_UPDATE_TIME'
};
